(() => {
  const RECENT_KEY = 'myd-recent-searches';
  const RECENT_MAX = 8;
  // Kept in sync with icon.liquid's 'cart' icon so the button's resting
  // state (set from JS, not Liquid) still shows it.
  const QA_ADD_ICON_HTML =
    '<span class="myd-search-qa__add-icon" aria-hidden="true">' +
    '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-cart" fill="none" viewBox="0 0 18 19">' +
    '<path d="M3.09333 5.87954L16.2853 5.87945V5.87945C16.3948 5.8795 16.4836 5.96831 16.4836 6.07785V11.4909C16.4836 11.974 16.1363 12.389 15.6603 12.4714C11.3279 13.2209 9.49656 13.2033 5.25251 13.9258C4.68216 14.0229 4.14294 13.6285 4.0774 13.0537C3.77443 10.3963 2.99795 3.58502 2.88887 2.62142C2.75288 1.42015 0.905376 1.51528 0.283581 1.51478" stroke="currentColor"/>' +
    '<path d="M13.3143 16.8554C13.3143 17.6005 13.9183 18.2045 14.6634 18.2045C15.4085 18.2045 16.0125 17.6005 16.0125 16.8554C16.0125 16.1104 15.4085 15.5063 14.6634 15.5063C13.9183 15.5063 13.3143 16.1104 13.3143 16.8554Z" fill="currentColor"/>' +
    '<path d="M3.72831 16.8554C3.72831 17.6005 4.33233 18.2045 5.07741 18.2045C5.8225 18.2045 6.42651 17.6005 6.42651 16.8554C6.42651 16.1104 5.8225 15.5063 5.07741 15.5063C4.33233 15.5063 3.72831 16.1104 3.72831 16.8554Z" fill="currentColor"/>' +
    '</svg>' +
    '</span>';
  const qaAddRestingHtml = (label) =>
    `${QA_ADD_ICON_HTML}<span class="myd-search-qa__add-label">${label}</span>`;

  const money = (cents) => {
    const amount = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR',
        maximumFractionDigits: 0
      }).format(amount);
    } catch (e) {
      return `₹${Math.round(amount)}`;
    }
  };

  const getRecent = () => {
    try {
      const raw = localStorage.getItem(RECENT_KEY);
      const list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list.filter((x) => typeof x === 'string' && x.trim()) : [];
    } catch (e) {
      return [];
    }
  };

  const setRecent = (list) => {
    try {
      localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, RECENT_MAX)));
    } catch (e) {
      /* ignore */
    }
  };

  window.MYDSearchRecent = {
    add(term) {
      const value = String(term || '').trim();
      if (!value) return;
      const next = [value, ...getRecent().filter((t) => t.toLowerCase() !== value.toLowerCase())];
      setRecent(next);
      document.dispatchEvent(new CustomEvent('myd:recent-searches'));
    },
    list: getRecent,
    renderAll() {
      document.querySelectorAll('[data-myd-recent-searches]').forEach((section) => {
        const listEl = section.querySelector('[data-myd-recent-list]');
        if (!listEl) return;
        const items = getRecent();
        if (!items.length) {
          section.hidden = true;
          listEl.innerHTML = '';
          return;
        }
        section.hidden = false;
        const type = section.closest('form')?.querySelector('[name="type"]')?.value
          || document.querySelector('.myd-search__form [name="type"]')?.value
          || 'product';
        listEl.innerHTML = items
          .map((label) => {
            const href = `/search?q=${encodeURIComponent(label)}&type=${encodeURIComponent(type)}&options%5Bprefix%5D=last`;
            const safe = label.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
            return `<a class="myd-search-discovery__chip" href="${href}" data-myd-search-chip="${safe}"><svg class="myd-search-discovery__chip-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="11" cy="11" r="6.5" stroke="currentColor" stroke-width="1.8"/><path d="M16.2 16.2L20 20" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>${safe}</a>`;
          })
          .join('');
      });
    }
  };

  class MydSearchQuickAdd extends HTMLElement {
    constructor() {
      super();
      this.cache = {};
      this.pending = {};
      this.currentHandle = null;
    }

    connectedCallback() {
      if (window.__mydSearchQuickAddBound) return;
      window.__mydSearchQuickAddBound = this;

      this.overlay = this.querySelector('[data-myd-qa-overlay]');
      this.sheet = this.querySelector('.myd-search-qa__sheet');
      this.gallery = this.querySelector('[data-myd-qa-gallery]');
      this.dots = this.querySelector('[data-myd-qa-dots]');
      this.flagsEl = this.querySelector('[data-myd-qa-flags]');
      this.typeEl = this.querySelector('[data-myd-qa-type]');
      this.ratingEl = this.querySelector('[data-myd-qa-rating]');
      this.ratingScoreEl = this.querySelector('[data-myd-qa-rating-score]');
      this.titleEl = this.querySelector('[data-myd-qa-title]');
      this.priceEl = this.querySelector('[data-myd-qa-price]');
      this.variantsEl = this.querySelector('[data-myd-qa-variants]');
      this.variantInput = this.querySelector('[data-myd-qa-variant]');
      this.qtyInput = this.querySelector('[data-myd-qa-qty]');
      this.qtyMinusBtn = this.querySelector('[data-myd-qa-qty-minus]');
      this.qtyPlusBtn = this.querySelector('[data-myd-qa-qty-plus]');
      this.addBtn = this.querySelector('[data-myd-qa-add]');
      this.success = this.querySelector('[data-myd-qa-success]');
      this.sizeWarning = this.querySelector('[data-myd-qa-size-warning]');
      this.form = this.querySelector('[data-myd-qa-form]');
      this.wishBtn = this.querySelector('[data-myd-qa-wish]');
      this.sizeChartBtn = this.querySelector('[data-myd-qa-size-chart], .myd-search-qa__size-chart');
      this.productTitleEl = this.querySelector('[data-myd-qa-product]');
      this.topSellerIds = this.getAttribute('data-top-seller-ids') || '';
      this._currentProduct = null;

      this.querySelector('[data-myd-qa-close]')?.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
        this.close({ keepCartOpen: true });
      });
      this.overlay?.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
        this.close({ keepCartOpen: true });
      });
      // Clicks inside the sheet must not bubble to cart-drawer body-close
      this.sheet?.addEventListener('click', (e) => {
        e.stopPropagation();
      });
      this.form?.addEventListener('submit', (e) => {
        e.preventDefault();
        if (this.addBtn?.classList.contains('is-go-to-cart')) {
          this.goToCart();
          return;
        }
        this.addToCart();
      });
      this.wishBtn?.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.toggleWish();
      });
      this.qtyMinusBtn?.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.stepQty(-1);
      });
      this.qtyPlusBtn?.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.stepQty(1);
      });
      // Size chart: call MYDSizeChart with this sheet's product (never PDP Kiwi meta).
      // myd-kiwi-size-chart.js intentionally skips QA triggers so we own this path.
      this.sizeChartBtn?.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
        this.openSizeChart(e.currentTarget);
      });
      this.sizeChartBtn?.addEventListener(
        'pointerdown',
        () => {
          try {
            window.MYDSizeChart?.prefetch?.();
          } catch (err) {
            /* ignore */
          }
        },
        { passive: true }
      );

      document.addEventListener('click', (event) => {
        const btn = event.target.closest?.('[data-myd-quick-add]');
        if (!btn || btn.disabled) return;
        event.preventDefault();
        event.stopPropagation();
        const handle = btn.getAttribute('data-product-handle');
        if (handle) {
          this.open(handle, {
            fromCart: this.isCartQuickAdd(btn),
            forceTopSeller: btn.getAttribute('data-myd-qa-topseller') === '1',
            rating: this.readRatingFromTrigger(btn),
          });
        }
      });

      // Warm the cache the instant a finger/pointer lands on a quick-add button,
      // so the fetch is usually done before the tap "click" fires.
      const prefetchFromEvent = (event) => {
        const btn = event.target.closest?.('[data-myd-quick-add]');
        if (!btn || btn.disabled) return;
        this.prefetch(btn.getAttribute('data-product-handle'));
      };
      document.addEventListener('pointerdown', prefetchFromEvent, { passive: true });
      document.addEventListener('touchstart', prefetchFromEvent, { passive: true });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) {
          e.preventDefault();
          e.stopPropagation();
          this.close({ keepCartOpen: true });
        }
      });

      this.bindSheetDrag();
      // In case myd-sheet-drag.js was still booting
      setTimeout(() => this.bindSheetDrag(), 0);
      setTimeout(() => this.bindSheetDrag(), 400);

      this.preloadAll();
    }

    bindSheetDrag() {
      if (!this.sheet || this.sheet.__mydDragBound) return;
      if (!window.MYDSheetDrag || typeof window.MYDSheetDrag.bind !== 'function') return;
      window.MYDSheetDrag.bind(this.sheet, {
        onClose: () => this.close({ keepCartOpen: true }),
        overlay: this.overlay,
        handleSelector: '[data-myd-qa-drag], .myd-search-qa__handle, .myd-search-qa__drag',
        headerSelector: '.myd-search-qa__head, [data-myd-sheet-header]',
        scrollSelector: null, // sheet itself scrolls
      });
    }

    warmGalleryImages(product, count = 2) {
      const list = (product?.images || []).slice(0, count);
      if (!list.length && product?.featured_image) list.push(product.featured_image);
      list.forEach((src) => {
        const url = typeof src === 'string' ? src : src?.src || '';
        if (!url) return;
        try {
          const img = new Image();
          img.decoding = 'async';
          img.fetchPriority = 'high';
          img.src = url.startsWith('//') ? `https:${url}` : url;
        } catch (e) {
          /* ignore */
        }
      });
    }

    prefetch(handle) {
      if (!handle || this.cache[handle] || this.pending?.[handle]) return null;
      this.pending = this.pending || {};
      const req = fetch(`/products/${handle}.js`)
        .then((res) => {
          if (!res.ok) throw new Error('load failed');
          return res.json();
        })
        .then((product) => {
          this.cache[handle] = product;
          this.warmGalleryImages(product, 2);
          delete this.pending[handle];
          return product;
        })
        .catch(() => {
          delete this.pending[handle];
          return null;
        });
      this.pending[handle] = req;
      return req;
    }

    preloadAll() {
      // Intentionally no-op: eagerly prefetching every [data-myd-quick-add]
      // product.js on page load caused dozens of unnecessary requests.
      // Prefetch still runs on pointerdown/touchstart of a specific + button.
    }

    isOpen() {
      return this.sheet && !this.sheet.hasAttribute('hidden');
    }

    isCartQuickAdd(btn) {
      if (!btn) return false;
      return Boolean(
        btn.closest(
          '#mini-cart, mini-cart, [data-myd-cart], .myd-cart, .myd-cart-drawer-host, .myd-cart__upsells, .myd-cart__yml-scroller, .myd-cart__yml-card'
        )
      );
    }

    getCartPanel() {
      return (
        document.getElementById('mini-cart') ||
        document.querySelector('mini-cart.cart-drawer') ||
        document.querySelector('mini-cart.myd-cart-drawer-host') ||
        document.querySelector('details[open] > .cart-drawer')
      );
    }

    mountInCart(fromCart) {
      const panel = this.getCartPanel();
      if (fromCart && panel) {
        if (!this._homeParent) {
          this._homeParent = this.parentElement;
          this._homeNext = this.nextSibling;
        }
        // Live inside the drawer panel so the sheet is clipped to it
        if (this.parentElement !== panel) {
          panel.appendChild(this);
        }
        this.classList.add('myd-search-qa--cart');
        panel.classList.add('myd-cart--qa-open');
        this._openedFromCart = true;
        this.pinToCartPanel(panel);
        return;
      }

      this.clearCartPin();
      this.restoreHomeMount();
      this._openedFromCart = false;
      document.querySelectorAll('.myd-cart--qa-open').forEach((el) => {
        el.classList.remove('myd-cart--qa-open');
      });
    }

    pinToCartPanel(panel) {
      if (!panel) return;
      const apply = () => {
        if (!this.classList.contains('myd-search-qa--cart')) return;
        // absolute fill inside fixed drawer panel — clear any leftover inline body pin
        this.style.position = '';
        this.style.top = '';
        this.style.left = '';
        this.style.width = '';
        this.style.height = '';
        this.style.right = '';
        this.style.bottom = '';
        this.style.zIndex = '';
      };
      apply();
      this._cartPinHandler = apply;
      window.addEventListener('resize', apply);
    }

    clearCartPin() {
      if (this._cartPinHandler) {
        window.removeEventListener('resize', this._cartPinHandler);
        this._cartPinHandler = null;
      }
      this.style.position = '';
      this.style.top = '';
      this.style.left = '';
      this.style.width = '';
      this.style.height = '';
      this.style.right = '';
      this.style.bottom = '';
      this.style.zIndex = '';
    }

    restoreHomeMount() {
      this.classList.remove('myd-search-qa--cart');
      this.clearCartPin();
      if (!this._homeParent) return;
      if (this.parentElement === this._homeParent) return;
      if (this._homeNext && this._homeNext.parentNode === this._homeParent) {
        this._homeParent.insertBefore(this, this._homeNext);
      } else {
        this._homeParent.appendChild(this);
      }
    }

    async open(handle, options = {}) {
      const fromCart = Boolean(options.fromCart);
      this._forceTopSeller = Boolean(options.forceTopSeller);
      this._pendingRating = options.rating || null;
      try {
        window.MYDAccountHideLoader?.();
      } catch (e) {
        /* ignore */
      }
      this.mountInCart(fromCart);
      this.currentHandle = handle;
      this.success.hidden = true;
      this.clearSizeWarning();
      this.setQty(1);
      this.setAddButtonResting();
      this.overlay.hidden = false;
      this.sheet.hidden = false;
      this.classList.add('is-open');
      document.body.classList.add('myd-search-qa-open');
      document.body.classList.toggle('myd-search-qa-in-cart', fromCart);
      this.bindSheetDrag();

      if (this.cache[handle]) {
        this.clearSkeleton();
        this.render(this.cache[handle]);
        return;
      }

      this.showSkeleton();

      try {
        const product = await (this.pending?.[handle] || this.prefetch(handle));
        if (!product) throw new Error('load failed');
        if (this.currentHandle !== handle) return;
        this.clearSkeleton();
        this.render(product);
      } catch (err) {
        if (this.currentHandle !== handle) return;
        this.clearSkeleton();
        this.gallery.innerHTML = '';
        this.dots.innerHTML = '';
        this.variantsEl.innerHTML = '';
        this.renderFlags(null);
        this.renderRating(null);
        this.typeEl.textContent = '';
        this.priceEl.textContent = '';
        this.titleEl.textContent = 'Could not load product';
        this.titleEl.setAttribute('href', '#');
        this.addBtn.disabled = true;
        this._currentProduct = null;
      }
    }

    readRatingFromTrigger(btn) {
      if (!btn) return null;
      const attrAvg = Number.parseFloat(btn.getAttribute('data-rating') || '');
      const attrCount = Number.parseInt(btn.getAttribute('data-rating-count') || '', 10);
      if (attrAvg > 0 && attrCount > 0) {
        return { average: attrAvg, count: attrCount };
      }

      const card =
        btn.closest(
          '.myd-search-card, [class*="ai-you-might-like-product-"], [class*="luxury-card-"], .luxury-product-card, .myd-yml-carousel__card, .myd-cart__yml-card'
        ) || btn.parentElement;
      if (!card) return null;

      const scoreEl =
        card.querySelector('[data-myd-card-rating-score], [class*="rating-score"]') ||
        card.querySelector('.ai-you-might-like-rating-score, .myd-search-card__rating-score');
      const ratingRoot =
        scoreEl?.closest('[data-myd-card-rating], [class*="rating"]') ||
        card.querySelector('[data-myd-card-rating], [class*="rating-"]');
      if (ratingRoot?.classList?.contains('is-empty')) return null;

      const avg = Number.parseFloat((scoreEl?.textContent || '').trim());
      if (!(avg > 0)) return null;
      return { average: avg, count: 1 };
    }

    renderRating(rating) {
      if (!this.ratingEl || !this.ratingScoreEl) return;
      const source = rating || this._pendingRating;
      const avg = Number.parseFloat(source?.average || source?.rating || 0);
      const count = Number.parseInt(source?.count || source?.rating_count || 0, 10);
      if (!(avg > 0) || !(count > 0)) {
        this.ratingEl.classList.add('is-empty');
        this.ratingEl.setAttribute('aria-hidden', 'true');
        this.ratingEl.removeAttribute('aria-label');
        this.ratingScoreEl.textContent = '0.0';
        return;
      }
      const score = (Math.round(avg * 100) / 100).toFixed(2).replace(/\.?0+$/, '');
      this.ratingScoreEl.textContent = score.includes('.') ? score : `${score}.0`;
      this.ratingEl.classList.remove('is-empty');
      this.ratingEl.removeAttribute('aria-hidden');
      this.ratingEl.setAttribute(
        'aria-label',
        `Rated ${this.ratingScoreEl.textContent} from ${count} review${count === 1 ? '' : 's'}`
      );
    }

    showSkeleton() {
      this.classList.add('is-loading');
      this.sheet?.setAttribute('aria-busy', 'true');
      this.renderFlags(null);
      this.renderRating(null);
      this.typeEl.innerHTML = '<span class="myd-search-qa__skel myd-search-qa__skel--type" aria-hidden="true"></span>';
      this.titleEl.removeAttribute('href');
      this.titleEl.innerHTML = '<span class="myd-search-qa__skel myd-search-qa__skel--title" aria-hidden="true"></span>';
      if (this.productTitleEl) {
        this.productTitleEl.textContent = '';
        this.productTitleEl.hidden = true;
      }
      this.priceEl.innerHTML = '<span class="myd-search-qa__skel myd-search-qa__skel--price" aria-hidden="true"></span>';
      this.gallery.innerHTML = `
        <div class="myd-search-qa__gallery-link myd-search-qa__skel myd-search-qa__skel--img" aria-hidden="true"></div>
        <div class="myd-search-qa__gallery-link myd-search-qa__skel myd-search-qa__skel--img" aria-hidden="true"></div>
      `;
      this.dots.innerHTML = '<span></span><span></span>';
      this.variantsEl.innerHTML = Array.from({ length: 4 }, () =>
        '<span class="myd-search-qa__skel myd-search-qa__skel--chip" aria-hidden="true"></span>'
      ).join('');
      this.variantInput.value = '';
      this.addBtn.disabled = true;
      this.addBtn.classList.remove('is-adding');
      this.addBtn.removeAttribute('aria-busy');
      this.addBtn.innerHTML = qaAddRestingHtml('Add To Cart');
      if (this.sizeChartBtn) {
        this.sizeChartBtn.disabled = true;
        this.sizeChartBtn.setAttribute('aria-busy', 'true');
      }
      if (this.wishBtn) {
        this.wishBtn.disabled = true;
        this.wishBtn.classList.remove('is-hearted');
        this.wishBtn.setAttribute('aria-pressed', 'false');
      }
    }

    clearSkeleton() {
      this.classList.remove('is-loading');
      this.sheet?.removeAttribute('aria-busy');
      if (this.wishBtn) this.wishBtn.disabled = false;
      if (this.sizeChartBtn) {
        this.sizeChartBtn.disabled = false;
        this.sizeChartBtn.removeAttribute('aria-busy');
      }
    }

    close(options = {}) {
      const keepCartOpen = options.keepCartOpen !== false && this._openedFromCart;
      this.overlay.hidden = true;
      this.sheet.hidden = true;
      this.classList.remove('is-open');
      document.body.classList.remove('myd-search-qa-open', 'myd-search-qa-in-cart');
      document.querySelectorAll('.myd-cart--qa-open').forEach((el) => {
        el.classList.remove('myd-cart--qa-open');
      });

      // Defer unmount so the same click cannot hit cart-drawer onBodyClick as "outside"
      const finish = () => {
        this.restoreHomeMount();
        this._openedFromCart = false;
        this._forceTopSeller = false;
      };
      if (keepCartOpen) {
        setTimeout(finish, 0);
      } else {
        finish();
      }
    }

    openSizeChart(button) {
      const product = this._currentProduct;
      if (!product) return;
      const btn = button || this.sizeChartBtn;
      const payload = Object.assign({}, product, {
        handle: product.handle || this.currentHandle || null,
        id: product.id || product.product || null,
      });
      if (!window.MYDSizeChart || typeof window.MYDSizeChart.open !== 'function') return;
      try {
        window.MYDSizeChart.open(payload, { fromQuickAdd: true, button: btn });
      } catch (err) {
        /* ignore */
      }
    }

    sizeLabel(variant) {
      if (!variant) return '';
      if (variant.option1 && !variant.option2 && !variant.option3) return variant.option1;
      const parts = [variant.option1, variant.option2, variant.option3].filter(Boolean);
      if (parts.length === 1) return parts[0];
      return variant.title || parts.join(' / ');
    }

    /** Normalize Shopify product.js options → [{ name, values }]. */
    optionDefs(product) {
      const variants = product?.variants || [];
      const raw = product?.options || [];
      if (!raw.length) return [];

      // product.js: options is string[] of names; values come from variants
      if (typeof raw[0] === 'string') {
        return raw.map((name, index) => {
          const key = `option${index + 1}`;
          const values = [];
          const seen = new Set();
          variants.forEach((v) => {
            const val = v[key];
            if (val == null || val === '' || seen.has(val)) return;
            seen.add(val);
            values.push(val);
          });
          return { name, values };
        }).filter((o) => o.name && o.name !== 'Title');
      }

      // Rare shape: [{ name, values }]
      return raw
        .map((o) => ({
          name: o?.name || o?.value || '',
          values: Array.isArray(o?.values) ? o.values.slice() : [],
        }))
        .filter((o) => o.name && o.name !== 'Title');
    }

    isMultiOptionProduct(product) {
      return this.optionDefs(product).length > 1;
    }

    variantMatchesSelection(variant, selected) {
      if (!variant || !selected) return false;
      for (let i = 0; i < selected.length; i++) {
        if (selected[i] == null || selected[i] === '') continue;
        if (variant[`option${i + 1}`] !== selected[i]) return false;
      }
      return true;
    }

    findSelectedVariant(product, selected) {
      const variants = product?.variants || [];
      const defs = this.optionDefs(product);
      if (!defs.length) return null;
      if (selected.length < defs.length || selected.some((v) => v == null || v === '')) return null;
      return (
        variants.find((v) => {
          for (let i = 0; i < defs.length; i++) {
            if (v[`option${i + 1}`] !== selected[i]) return false;
          }
          return true;
        }) || null
      );
    }

    /** Value is choosable if some available variant matches other selections + this value. */
    isOptionValueAvailable(product, optionIndex, value, selected) {
      const variants = product?.variants || [];
      return variants.some((v) => {
        if (!v.available) return false;
        if (v[`option${optionIndex + 1}`] !== value) return false;
        for (let i = 0; i < selected.length; i++) {
          if (i === optionIndex) continue;
          if (selected[i] == null || selected[i] === '') continue;
          if (v[`option${i + 1}`] !== selected[i]) return false;
        }
        return true;
      });
    }

    applySelectedVariant(product, variant) {
      if (!variant) {
        this.variantInput.value = '';
        this.setAddButtonResting();
        return;
      }
      this.variantInput.value = variant.id;
      this.clearSizeWarning();
      this.setAddButtonResting();
      this.priceEl.innerHTML = this.formatPriceHtml(variant.price, variant.compare_at_price);
      this.renderFlags(product, variant.price, variant.compare_at_price);
      this.syncWishButton(product);
      if (variant.featured_image?.src) {
        const first = this.gallery.querySelector('img');
        if (first) first.src = variant.featured_image.src;
      }
    }

    syncMultiOptionAvailability(product) {
      const selected = this._selectedOptions || [];
      this.variantsEl?.querySelectorAll('[data-myd-qa-option-btn]').forEach((btn) => {
        const index = Number(btn.dataset.optionIndex);
        const value = btn.dataset.value;
        const available = this.isOptionValueAvailable(product, index, value, selected);
        btn.disabled = !available && !btn.classList.contains('selected');
        if (btn.classList.contains('selected') && !available) {
          // Keep selected visible but mark unavailable if stock changed mid-pick
          btn.disabled = true;
        }
      });
    }

    onMultiOptionPick(product, optionIndex, value, btn) {
      if (!this._selectedOptions) this._selectedOptions = [];
      const group = btn.closest('[data-myd-qa-option-group]');
      group?.querySelectorAll('[data-myd-qa-option-btn]').forEach((b) => b.classList.remove('selected'));
      btn.classList.add('selected');
      this._selectedOptions[optionIndex] = value;

      // Clear later options that are no longer valid with this pick
      const defs = this.optionDefs(product);
      for (let i = optionIndex + 1; i < defs.length; i++) {
        const cur = this._selectedOptions[i];
        if (cur == null || cur === '') continue;
        if (!this.isOptionValueAvailable(product, i, cur, this._selectedOptions)) {
          this._selectedOptions[i] = null;
          const later = this.variantsEl?.querySelector(`[data-myd-qa-option-group][data-option-index="${i}"]`);
          later?.querySelectorAll('[data-myd-qa-option-btn]').forEach((b) => b.classList.remove('selected'));
        }
      }

      this.syncMultiOptionAvailability(product);
      const match = this.findSelectedVariant(product, this._selectedOptions);
      if (match && match.available) {
        this.applySelectedVariant(product, match);
      } else {
        this.variantInput.value = '';
        this.setAddButtonResting();
        // Restore product-level price until a full combo is chosen
        this.priceEl.innerHTML = this.formatPriceHtml(product.price, product.compare_at_price);
        this.renderFlags(product, product.price, product.compare_at_price);
      }
    }

    renderMultiOptionPicker(product) {
      const defs = this.optionDefs(product);
      this._selectedOptions = defs.map(() => null);
      this.variantsEl.classList.add('myd-search-qa__variants--multi');

      const sizesLabel = this.querySelector('.myd-search-qa__label');
      if (sizesLabel) sizesLabel.textContent = 'Select options';

      defs.forEach((def, index) => {
        const group = document.createElement('div');
        group.className = 'myd-search-qa__option-group';
        group.dataset.optionIndex = String(index);
        group.setAttribute('data-myd-qa-option-group', '');

        const nameEl = document.createElement('div');
        nameEl.className = 'myd-search-qa__option-name';
        nameEl.textContent = def.name;
        group.appendChild(nameEl);

        const row = document.createElement('div');
        row.className = 'myd-search-qa__option-values';

        def.values.forEach((value) => {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'myd-search-qa__variant-btn';
          btn.setAttribute('data-myd-qa-option-btn', '');
          btn.dataset.optionIndex = String(index);
          btn.dataset.value = value;
          btn.textContent = value;
          const available = this.isOptionValueAvailable(product, index, value, this._selectedOptions);
          if (!available) btn.disabled = true;
          else {
            btn.addEventListener('click', () => this.onMultiOptionPick(product, index, value, btn));
          }
          row.appendChild(btn);
        });

        group.appendChild(row);
        this.variantsEl.appendChild(group);

        // Auto-select sole value (e.g. Saree → Free Size)
        if (def.values.length === 1) {
          const onlyBtn = row.querySelector('[data-myd-qa-option-btn]:not(:disabled)');
          if (onlyBtn) {
            this.onMultiOptionPick(product, index, def.values[0], onlyBtn);
          }
        }
      });
    }

    renderFlatVariantPicker(product) {
      this.variantsEl.classList.remove('myd-search-qa__variants--multi');
      const sizesLabel = this.querySelector('.myd-search-qa__label');
      if (sizesLabel) sizesLabel.textContent = 'Sizes';

      (product.variants || []).forEach((variant) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'myd-search-qa__variant-btn';
        btn.textContent = this.sizeLabel(variant);
        btn.dataset.id = variant.id;
        if (!variant.available) {
          btn.disabled = true;
        } else {
          btn.addEventListener('click', () => {
            this.variantsEl.querySelectorAll('.myd-search-qa__variant-btn').forEach((b) => b.classList.remove('selected'));
            btn.classList.add('selected');
            this.applySelectedVariant(product, variant);
          });
        }
        this.variantsEl.appendChild(btn);
      });
    }

    formatPriceHtml(price, compareAt) {
      const sell = Number(price) || 0;
      const mrp = Number(compareAt) || 0;
      const save = mrp > sell ? mrp - sell : 0;
      let html = money(sell);
      if (mrp > sell) {
        html += `<span class="compare">${money(mrp)}</span>`;
        html += `<span class="save">Save ${money(save)}</span>`;
      }
      return html;
    }

    discountPercent(price, compareAt) {
      const sell = Number(price) || 0;
      const mrp = Number(compareAt) || 0;
      if (!(mrp > sell) || mrp <= 0) return 0;
      return Math.round(((mrp - sell) / mrp) * 100);
    }

    isTopSellerProduct(product) {
      if (this._forceTopSeller) return true;
      if (!product?.id || !this.topSellerIds) return false;
      return this.topSellerIds.includes(`,${product.id},`);
    }

    renderFlags(product, price, compareAt) {
      if (!this.flagsEl) return;
      if (!product) {
        this.flagsEl.innerHTML = '';
        return;
      }
      const parts = [];
      if (this.isTopSellerProduct(product)) {
        parts.push('<span class="myd-search-qa__flag myd-search-qa__flag--topseller">Top Seller</span>');
      }
      const pct = this.discountPercent(price, compareAt);
      if (pct >= 1) {
        parts.push(`<span class="myd-search-qa__flag myd-search-qa__flag--off">${pct}% OFF</span>`);
      }
      this.flagsEl.innerHTML = parts.join('');
    }

    render(product) {
      this.clearSkeleton();
      this._currentProduct = product;
      const productUrl = product.url || (this.currentHandle ? `/products/${this.currentHandle}` : '#');
      this.renderFlags(product, product.price, product.compare_at_price);
      this.typeEl.textContent = product.type || '';
      this.renderRating(this._pendingRating);
      this.titleEl.textContent = product.title || '';
      this.titleEl.setAttribute('href', productUrl);
      if (this.productTitleEl) {
        const t = String(product.title || '').trim();
        if (t) {
          this.productTitleEl.textContent = t;
          this.productTitleEl.setAttribute('title', t);
          this.productTitleEl.hidden = false;
        } else {
          this.productTitleEl.textContent = '';
          this.productTitleEl.removeAttribute('title');
          this.productTitleEl.hidden = true;
        }
      }
      this.priceEl.innerHTML = this.formatPriceHtml(product.price, product.compare_at_price);

      const images = (product.images || []).slice(0, 6);
      if (!images.length && product.featured_image) images.push(product.featured_image);
      // First two images must paint immediately (visible pair in the sheet).
      this.warmGalleryImages(product, 2);
      this.gallery.innerHTML = images
        .map((src, index) => {
          const imgSrc = typeof src === 'string' ? src : src?.src || src;
          const eager = index < 2;
          const loading = eager ? 'eager' : 'lazy';
          const priority = eager ? ' fetchpriority="high"' : '';
          return `<a class="myd-search-qa__gallery-link" href="${productUrl}"><img src="${imgSrc}" alt="${(product.title || '').replace(/"/g, '&quot;')}" loading="${loading}" decoding="async"${priority}></a>`;
        })
        .join('');
      this.renderDots(images.length);

      this.variantsEl.innerHTML = '';
      this.variantInput.value = '';
      this._selectedOptions = null;
      this.clearSizeWarning();
      const availableVariants = (product.variants || []).filter((v) => v.available);
      const hasOnlyDefault =
        availableVariants.length === 1 &&
        (!product.options?.length ||
          (product.options.length === 1 &&
            (product.options[0] === 'Title' || product.options[0]?.name === 'Title')));

      if (this.isMultiOptionProduct(product) && !hasOnlyDefault) {
        this.renderMultiOptionPicker(product);
      } else {
        this.renderFlatVariantPicker(product);
      }

      // Never preselect a size. Only auto-bind Title-only single variants.
      this._hasOnlyDefault = hasOnlyDefault;
      this._onlyVariantId = hasOnlyDefault ? availableVariants[0].id : null;
      if (hasOnlyDefault) {
        const only = availableVariants[0];
        const onlyBtn = this.variantsEl.querySelector(`[data-id="${only.id}"]`);
        if (onlyBtn) onlyBtn.classList.add('selected');
        this.variantInput.value = only.id;
      }

      this.setAddButtonResting();
      this.syncWishButton(product);

      const syncDots = () => {
        const imgs = [...this.gallery.querySelectorAll('img')];
        if (!imgs.length) return;
        const perPage = this.qaImagesPerPage();
        if (this.dots.querySelectorAll('span').length !== Math.ceil(imgs.length / perPage)) {
          this.renderDots(imgs.length);
        }
        const width = imgs[0].offsetWidth + 8;
        const imageIndex = Math.min(imgs.length - 1, Math.max(0, Math.round(this.gallery.scrollLeft / width)));
        const pageIndex = Math.floor(imageIndex / perPage);
        this.dots.querySelectorAll('span').forEach((dot, i) => {
          dot.classList.toggle('is-active', i === pageIndex);
        });
      };
      this.gallery.onscroll = syncDots;
      window.removeEventListener('resize', this._onQaGalleryResize || (() => {}));
      this._onQaGalleryResize = syncDots;
      window.addEventListener('resize', this._onQaGalleryResize);
    }

    /** 3 images per row on the wider desktop sheet, 2 on the mobile bottom sheet. */
    qaImagesPerPage() {
      return window.matchMedia('(min-width: 750px)').matches ? 3 : 2;
    }

    /** One dot per scrollable page of images, not per image — keeps every dot reachable and clickable. */
    renderDots(imageCount) {
      const perPage = this.qaImagesPerPage();
      const pageCount = Math.max(1, Math.ceil(imageCount / perPage));
      this.dots.innerHTML = Array.from(
        { length: pageCount },
        (_, i) => `<span class="${i === 0 ? 'is-active' : ''}" data-index="${i}" role="button" aria-label="Go to slide ${i + 1}" tabindex="0"></span>`
      ).join('');

      this.dots.querySelectorAll('span').forEach((dot, index) => {
        dot.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const target = this.gallery?.children?.[index * perPage];
          if (target && typeof target.offsetLeft === 'number') {
            this.gallery.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
          } else {
            const firstImg = this.gallery?.querySelector('img');
            const width = firstImg ? (firstImg.offsetWidth + 8) * perPage : this.gallery.clientWidth;
            this.gallery.scrollTo({ left: index * width, behavior: 'smooth' });
          }
        });
      });
    }

    clearSizeWarning() {
      if (!this.sizeWarning) return;
      this.sizeWarning.textContent = '';
      this.sizeWarning.classList.remove('is-visible');
    }

    showSizeWarning(message) {
      if (!this.sizeWarning) return;
      this.sizeWarning.textContent = message || 'Please select a size before adding to cart.';
      this.sizeWarning.classList.add('is-visible');
      try {
        this.sizeWarning.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      } catch (e) {}
    }

    syncWishButton(product) {
      if (!this.wishBtn || !product) return;
      const handle = this.currentHandle || product.handle || '';
      this.wishBtn.setAttribute('data-product-handle', handle);
      const hearted = !!(handle && window.MydWishlist?.hasItem(handle));
      this.wishBtn.classList.toggle('is-hearted', hearted);
      this.wishBtn.setAttribute('aria-pressed', hearted ? 'true' : 'false');
      this.wishBtn.setAttribute('aria-label', hearted ? 'Remove from wishlist' : 'Add to wishlist');
    }

    setQty(value) {
      if (!this.qtyInput) return;
      const clamped = Math.min(10, Math.max(1, parseInt(value, 10) || 1));
      this.qtyInput.value = String(clamped);
      if (this.qtyMinusBtn) this.qtyMinusBtn.disabled = clamped <= 1;
      if (this.qtyPlusBtn) this.qtyPlusBtn.disabled = clamped >= 10;
    }

    stepQty(delta) {
      this.setQty(parseInt(this.qtyInput?.value || '1', 10) + delta);
    }

    toggleWish() {
      if (!this.wishBtn || !window.MydWishlist) return;
      const handle = this.wishBtn.getAttribute('data-product-handle') || this.currentHandle;
      if (!handle) return;

      const already = window.MydWishlist.hasItem(handle);
      window.MydWishlist.toggle('default', handle);

      if (window.MYDWishUI?.broadcast) {
        window.MYDWishUI.broadcast(handle, !already);
      } else {
        document.querySelectorAll(`[data-myd-wish][data-product-handle="${handle}"]`).forEach((btn) => {
          btn.classList.toggle('is-hearted', !already);
          btn.setAttribute('aria-pressed', !already ? 'true' : 'false');
        });
      }

      if (!already && window.MYDPdpWishlist) {
        window.MYDPdpWishlist._pendingAnchor = this.wishBtn;
        window.MYDPdpWishlist.onWishAdded(this.wishBtn);
      }
    }

    async addToCart() {
      if (!this.variantInput.value) {
        const multi = this._currentProduct && this.isMultiOptionProduct(this._currentProduct);
        this.showSizeWarning(
          multi ? 'Please select all options before adding to cart.' : 'Please select a size before adding to cart.'
        );
        return;
      }
      if (this.addBtn?.classList.contains('is-adding')) return;

      this.clearSizeWarning();
      this.setAddButtonAdding(true);
      try {
        // Only treat as in-cart when the sheet was opened from cart upsells.
        // Do NOT probe [data-myd-cart] — that node is always present with the MYD engine.
        const fromCart =
          this._openedFromCart ||
          this.classList.contains('myd-search-qa--cart') ||
          document.body.classList.contains('mini-cart--open') ||
          document.body.classList.contains('mini-cart--opening');

        const payload = {
          id: this.variantInput.value,
          quantity: parseInt(this.qtyInput?.value || '1', 10) || 1,
        };

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload),
        });
        if (!response.ok) throw new Error('add failed');
        await response.json();

        // Instant feedback — don't wait on drawer section re-fetch.
        this.showAddedToast(payload.quantity);
        this.setAddButtonGoToCart();

        try {
          const product = this.cache?.[this.currentHandle];
          document.dispatchEvent(
            new CustomEvent('myd:quick-add:success', {
              detail: {
                handle: this.currentHandle || '',
                productId: product?.id || this.wishBtn?.getAttribute('data-product-id') || '',
                variantId: this.variantInput?.value || '',
              },
            })
          );
        } catch (_) {
          /* ignore */
        }

        // Refresh cart UI in the background. MYDCartRefresh emits cart:updated
        // (source: myd-refresh) when done — avoid also firing cart:refresh here
        // or we double-fetch and reintroduce the lag.
        const refresh =
          typeof window.MYDCartRefresh === 'function'
            ? window.MYDCartRefresh()
            : this.refreshCartDrawer();
        Promise.resolve(refresh).catch(() => {
          if (!fromCart) document.dispatchEvent(new CustomEvent('cart:refresh'));
        });
      } catch (err) {
        alert('Could not add to cart. Please try again.');
        this.setAddButtonResting();
      }
    }

    goToCart() {
      // Keep Select your fit open underneath — drawer overlaps it.
      this.openCartDrawer();
    }

    openCartDrawer() {
      try {
        const mini =
          document.getElementById('mini-cart') ||
          document.querySelector('mini-cart') ||
          document.querySelector('cart-drawer mini-cart');
        if (mini && typeof mini.open === 'function') {
          mini.open();
          return;
        }
        const details =
          document.querySelector('cart-drawer details') ||
          document.querySelector('details.mini-cart') ||
          document.querySelector('details.cart-drawer-container');
        if (details && !details.hasAttribute('open')) {
          details.setAttribute('open', '');
          details.querySelector('summary')?.click?.();
        }
        document.body.classList.add('mini-cart--open');
      } catch (e) {
        /* ignore */
      }
    }

    showAddedToast(qty) {
      if (!this.success) return;
      const count = parseInt(qty, 10) || 1;
      this.success.textContent =
        count > 1 ? `${count} items added to your cart` : `${count} item added to your cart`;
      this.success.hidden = false;
      this.success.classList.remove('is-visible');
      void this.success.offsetWidth;
      this.success.classList.add('is-visible');
      if (this._toastHideTimer) clearTimeout(this._toastHideTimer);
      if (this._toastClearTimer) clearTimeout(this._toastClearTimer);
      this._toastHideTimer = setTimeout(() => {
        this.success.classList.remove('is-visible');
        this._toastClearTimer = setTimeout(() => {
          this.success.hidden = true;
        }, 260);
      }, 3000);
    }

    resetForAnotherAdd() {
      this.setQty(1);
      this.clearSizeWarning();
      this.setAddButtonResting();
      if (this._hasOnlyDefault && this._onlyVariantId) {
        this.variantInput.value = this._onlyVariantId;
        if (this.addBtn) this.addBtn.disabled = false;
        return;
      }
      const product = this._currentProduct;
      if (product && this.isMultiOptionProduct(product)) {
        // Rebuild so sole-value options (e.g. Free Size) re-auto-select
        this.variantsEl.innerHTML = '';
        this.variantInput.value = '';
        this.renderMultiOptionPicker(product);
        this.setAddButtonResting();
        if (this.addBtn) this.addBtn.disabled = !this.variantInput?.value;
        return;
      }
      this.variantsEl?.querySelectorAll('.myd-search-qa__variant-btn').forEach((b) => b.classList.remove('selected'));
      this.variantInput.value = '';
      if (this.addBtn) this.addBtn.disabled = false;
    }

    setAddButtonResting(label = 'Add To Cart') {
      if (!this.addBtn) return;
      this.addBtn.classList.remove('is-adding', 'is-go-to-cart');
      this.addBtn.removeAttribute('aria-busy');
      this.addBtn.innerHTML = qaAddRestingHtml(label);
      this.addBtn.disabled = !this.variantInput?.value;
      this.addBtn.setAttribute('type', 'submit');
    }

    setAddButtonGoToCart() {
      if (!this.addBtn) return;
      this.addBtn.classList.remove('is-adding');
      this.addBtn.classList.add('is-go-to-cart');
      this.addBtn.removeAttribute('aria-busy');
      this.addBtn.disabled = false;
      this.addBtn.innerHTML = qaAddRestingHtml('Go to cart');
      this.addBtn.setAttribute('type', 'submit');
    }

    setAddButtonAdding(isAdding, label = 'Adding...') {
      if (!this.addBtn) return;
      if (isAdding) {
        this.addBtn.disabled = true;
        this.addBtn.classList.add('is-adding');
        this.addBtn.classList.remove('is-go-to-cart');
        this.addBtn.setAttribute('aria-busy', 'true');
        this.addBtn.innerHTML =
          `<span class="myd-search-qa__add-spinner" aria-hidden="true"></span>` +
          `<span class="myd-search-qa__add-label">${label}</span>`;
      } else {
        this.setAddButtonResting();
      }
    }

    async refreshCartDrawer() {
      if (typeof window.MYDCartRefresh === 'function') {
        return window.MYDCartRefresh();
      }
      const mini = document.querySelector('mini-cart');
      const sections = mini?.getSectionsToRender?.().map((s) => s.section || s.id) || [
        mini?.dataset?.section || 'myd-cart-drawer',
        'cart-icon-bubble',
      ];
      try {
        const res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            sections,
            sections_url: window.location.pathname,
          }),
        });
        const parsed = await res.json();
        if (mini && typeof mini.updateContents === 'function') {
          mini.updateContents(parsed);
        } else if (mini && typeof mini.renderContents === 'function') {
          const wasOpen = document.body.classList.contains('mini-cart--open');
          mini.renderContents(parsed);
          if (wasOpen) {
            const details = document.querySelector('cart-drawer details, details.mini-cart');
            if (details && !details.hasAttribute('open') && typeof mini.open === 'function') {
              mini.open();
            }
          }
        }
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: parsed } }));
      } catch (e) {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }
    }
  }

  if (!customElements.get('myd-search-quick-add')) {
    customElements.define('myd-search-quick-add', MydSearchQuickAdd);
  }

  const goToSearch = (form) => {
    if (!form) return false;
    const input = form.querySelector('input[type="search"], input[name="q"]');
    const q = (input?.value || '').trim();
    if (!q) {
      input?.focus();
      return false;
    }
    window.MYDSearchRecent?.add?.(q);
    const aliasUrl = resolveSearchCollectionAlias(q);
    if (aliasUrl) {
      window.location.assign(aliasUrl);
      return true;
    }
    const action = form.getAttribute('action') || window.routes?.search_url || '/search';
    const params = new URLSearchParams();
    new FormData(form).forEach((value, key) => {
      if (key === 'q') return;
      params.append(key, value);
    });
    params.set('q', q);
    params.delete('options[unavailable_products]');
    params.delete('options');
    if (!params.get('options[prefix]')) params.set('options[prefix]', 'last');
    const query = params.toString();
    window.location.assign(query ? `${action}?${query}` : `${action}?q=${encodeURIComponent(q)}`);
    return true;
  };

  const resolveSearchCollectionAlias = (raw) => {
    const key = String(raw || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
    if (!key) return null;
    const compact = key.replace(/[\s\-_]+/g, '');
    const aliases = {
      shirts: '/collections/men-shirts',
      shirt: '/collections/men-shirts',
      bottomwear: '/collections/bottomwear-men',
      'bottom wear': '/collections/bottomwear-men',
      'bottom-wear': '/collections/bottomwear-men',
      'bottom ware': '/collections/bottomwear-men',
      'bottom waer': '/collections/bottomwear-men',
      bottoms: '/collections/bottomwear-men',
      hoodies: '/collections/men-hoodies-and-jackets',
      hoodie: '/collections/men-hoodies-and-jackets',
      jackets: '/collections/men-hoodies-and-jackets',
    };
    if (aliases[key]) return aliases[key];
    if (compact === 'bottomwear' || compact === 'bottomware' || compact === 'bottomwaer') {
      return '/collections/bottomwear-men';
    }
    if (compact === 'oversizedtees' || compact === 'oversizedtee') {
      return '/collections/men-oversized-tees';
    }
    return null;
  };

  const formatSuggestPrice = (product) => {
    const raw = product?.price;
    if (raw == null || raw === '') return '';
    const n = Number(String(raw).replace(/[^\d.]/g, ''));
    if (!Number.isFinite(n)) return String(raw);
    try {
      return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
        maximumFractionDigits: 0,
      })
        .format(n)
        .replace(/\u00a0/g, ' ')
        .replace('₹ ', '₹');
    } catch (e) {
      return `₹${Math.round(n).toLocaleString('en-IN')}`;
    }
  };

  const productImageUrl = (product) => {
    const img = product?.image || product?.featured_image;
    if (!img) return '';
    if (typeof img === 'string') {
      return img.startsWith('//') ? `https:${img}` : img;
    }
    if (img.url) {
      const u = String(img.url);
      return u.startsWith('//') ? `https:${u}` : u;
    }
    return '';
  };

  const renderSuggestMarkup = (products, term) => {
    const safeTerm = String(term || '').trim();
    const esc = (s) =>
      String(s || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    const items = (products || [])
      .map((p) => {
        const href = p.url || (p.handle ? `/products/${p.handle}` : '#');
        const title = esc(p.title || '');
        const price = esc(formatSuggestPrice(p));
        const img = productImageUrl(p);
        const imgHtml = img
          ? `<img class="myd-search-suggest__thumb" src="${esc(img)}" alt="" width="56" height="56" loading="lazy">`
          : `<span class="myd-search-suggest__thumb myd-search-suggest__thumb--empty" aria-hidden="true"></span>`;
        return `<li class="myd-search-suggest__item">
          <a class="myd-search-suggest__link" href="${esc(href)}">
            ${imgHtml}
            <span class="myd-search-suggest__meta">
              <span class="myd-search-suggest__title">${title}</span>
              ${price ? `<span class="myd-search-suggest__price">${price}</span>` : ''}
            </span>
          </a>
        </li>`;
      })
      .join('');

    const searchUrl = `${window.routes?.search_url || '/search'}?q=${encodeURIComponent(safeTerm)}&options[prefix]=last`;
    const empty = !items
      ? `<p class="myd-search-suggest__empty">No products found for “${esc(safeTerm)}”</p>`
      : '';

    return `<div class="myd-search-suggest__inner">
      <div class="myd-search-suggest__scroll">
        <ul class="myd-search-suggest__list" role="list">${items}</ul>
        ${empty}
      </div>
      <div class="myd-search-suggest__footer">
        <a class="myd-search-suggest__search-for" href="${esc(searchUrl)}">SEARCH FOR “${esc(safeTerm.toUpperCase())}”</a>
      </div>
    </div>`;
  };

  const suggestCache = Object.create(null);
  let suggestTimer = null;
  let suggestSeq = 0;

  const setSuggestMode = (root, on) => {
    if (!root) return;
    root.classList.toggle('is-suggesting', !!on);
    const panel = root.querySelector('[data-myd-search-suggest]');
    // Keep discovery behind — suggest is a dropdown overlay, not a full-page swap
    if (panel) panel.hidden = !on;
  };

  const closeAllSuggest = () => {
    document.querySelectorAll('.myd-search.is-suggesting').forEach((root) => {
      const panel = root.querySelector('[data-myd-search-suggest]');
      setSuggestMode(root, false);
      if (panel) panel.innerHTML = '';
    });
  };

  const runSuggest = async (input) => {
    const root = input?.closest?.('.myd-search');
    const panel = root?.querySelector?.('[data-myd-search-suggest]');
    if (!root || !panel) return;

    const term = String(input.value || '').trim();
    if (term.length < 2) {
      setSuggestMode(root, false);
      panel.innerHTML = '';
      return;
    }

    setSuggestMode(root, true);
    const seq = ++suggestSeq;
    const cacheKey = term.toLowerCase();
    if (suggestCache[cacheKey]) {
      panel.innerHTML = suggestCache[cacheKey];
      return;
    }

    panel.innerHTML =
      '<div class="myd-search-suggest__inner"><div class="myd-search-suggest__loading" role="status" aria-label="Searching"><span class="myd-search-suggest__spinner" aria-hidden="true"></span></div></div>';

    try {
      const limit = 8;
      const url =
        `/search/suggest.json?q=${encodeURIComponent(term)}` +
        `&resources[type]=product` +
        `&resources[limit]=${limit}` +
        `&resources[options][unavailable_products]=last`;

      const res = await fetch(url, { credentials: 'same-origin' });
      if (!res.ok) throw new Error(`suggest ${res.status}`);
      const data = await res.json();
      const products =
        data?.resources?.results?.products ||
        data?.resources?.products ||
        [];
      const html = renderSuggestMarkup(products, term);
      suggestCache[cacheKey] = html;
      if (seq !== suggestSeq) return;
      if (String(input.value || '').trim() !== term) return;
      panel.innerHTML = html;
    } catch (e) {
      if (seq !== suggestSeq) return;
      panel.innerHTML = renderSuggestMarkup([], term);
    }
  };

  const bindSuggest = () => {
    document.querySelectorAll('.myd-search__input').forEach((input) => {
      if (input.dataset.mydSuggestBound) return;
      input.dataset.mydSuggestBound = '1';
      input.addEventListener('input', () => {
        clearTimeout(suggestTimer);
        suggestTimer = setTimeout(() => runSuggest(input), 220);
      });
      input.addEventListener('focus', () => {
        if (String(input.value || '').trim().length >= 2) runSuggest(input);
      });
    });

    if (!document.documentElement.dataset.mydSuggestOutsideBound) {
      document.documentElement.dataset.mydSuggestOutsideBound = '1';
      document.addEventListener(
        'pointerdown',
        (event) => {
          const t = event.target;
          if (!(t instanceof Element)) return;
          if (!document.querySelector('.myd-search.is-suggesting')) return;
          if (t.closest('[data-myd-search-suggest]')) return;
          if (t.closest('.myd-search__field')) return;
          closeAllSuggest();
        },
        true
      );
      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        if (!document.querySelector('.myd-search.is-suggesting')) return;
        closeAllSuggest();
      });
    }
  };

  const bindSearchForms = () => {
    bindSuggest();
    document.querySelectorAll('.myd-search__form').forEach((form) => {
      if (form.dataset.mydBound) return;
      form.dataset.mydBound = '1';
      form.addEventListener('submit', (event) => {
        const input = form.querySelector('input[type="search"], input[name="q"]');
        const q = (input?.value || '').trim();
        if (!q) {
          event.preventDefault();
          input?.focus();
          return;
        }
        window.MYDSearchRecent.add(q);
        const aliasUrl = resolveSearchCollectionAlias(q);
        if (aliasUrl) {
          event.preventDefault();
          window.location.assign(aliasUrl);
        }
      });
    });

    if (!document.documentElement.dataset.mydSearchIconBound) {
      document.documentElement.dataset.mydSearchIconBound = '1';
      // Magnifying glass must always run search (modal/details can swallow native submit).
      document.addEventListener(
        'click',
        (event) => {
          const icon = event.target.closest?.('.myd-search__field-icon');
          if (!icon) return;
          const form = icon.closest('form.myd-search__form');
          if (!form) return;
          event.preventDefault();
          event.stopPropagation();
          goToSearch(form);
        },
        true
      );
    }

    document.addEventListener('click', (event) => {
      const chip = event.target.closest?.('[data-myd-search-chip]');
      if (!chip) return;
      const term = chip.getAttribute('data-myd-search-chip');
      if (term) window.MYDSearchRecent.add(term);
    });
  };

  const hoistToolbar = () => {
    document.querySelectorAll('.myd-search-toolbar').forEach((bar) => {
      if (bar.dataset.mydHoisted === '1') return;
      bar.dataset.mydHoisted = '1';
      document.body.appendChild(bar);
    });
  };

  const bindToolbar = () => {
    hoistToolbar();
    if (document.documentElement.dataset.mydToolbarDelegated) return;
    document.documentElement.dataset.mydToolbarDelegated = '1';

    document.addEventListener('myd:facets-rendered', hoistToolbar);

    document.addEventListener('click', (event) => {
      const filterBtn = event.target.closest?.('[data-myd-open-filters]');
      if (filterBtn) {
        event.preventDefault();
        closeSortSheet();
        const page =
          filterBtn.closest('.myd-search-page, [data-myd-collection-filters]') || document;
        const summary =
          page.querySelector?.('.mobile-facets__wrapper > details > summary') ||
          document.querySelector('.mobile-facets__wrapper > details > summary');
        if (summary) summary.click();
        document.dispatchEvent(new CustomEvent('myd:facet-sheet-open'));
        setTimeout(captureFacetSheetDraft, 50);
        return;
      }

      const sortBtn = event.target.closest?.('[data-myd-open-sort]');
      if (!sortBtn) return;
      event.preventDefault();
      const page =
        sortBtn.closest('.myd-search-page, [data-myd-collection-filters]') || document;
      openSortSheet(page);
    });

    const maybeCloseSortFromOutside = (event) => {
      const root = document.querySelector('.myd-search-sort.is-open');
      if (!root) return;
      if (event.target.closest?.('[data-myd-open-sort]')) return;
      if (eventPathHas(event, '.myd-search-sort__sheet') && !eventPathHas(event, '[data-myd-sort-close]')) {
        return;
      }
      closeSortSheet();
    };

    document.addEventListener('click', (event) => {
      const closeBtn = event.target.closest?.('[data-myd-sort-close]');
      if (closeBtn) {
        event.preventDefault();
        event.stopPropagation();
        closeSortSheet();
        return;
      }
      maybeCloseSortFromOutside(event);
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeSortSheet();
    });
  };

  const closeSortSheet = () => {
    document.querySelectorAll('.myd-search-sort.is-open').forEach((el) => {
      el.classList.remove('is-open');
    });
  };

  const closeAllFacetSheets = () => {
    document.querySelectorAll('.myd-facet-sheet details[open]').forEach((details) => {
      closeFacetSheet(details.closest('facet-drawer, .myd-facet-sheet'));
    });
  };

  const openSortSheet = (page) => {
    closeAllFacetSheets();
    let root = document.querySelector('.myd-search-sort');
    const select =
      page.querySelector('#SortBy-mobile') ||
      page.querySelector('#SortBy') ||
      page.querySelector('select[name="sort_by"]');

    if (!select) {
      const summary = page.querySelector('.mobile-facets__wrapper > details > summary');
      if (summary) summary.click();
      return;
    }

    if (!root) {
      root = document.createElement('div');
      root.className = 'myd-search-sort';
      root.innerHTML = `
        <button type="button" class="myd-search-sort__overlay" data-myd-sort-close aria-label="Close sort"></button>
        <div class="myd-search-sort__sheet" role="dialog" aria-modal="true" aria-label="Sort">
          <div class="myd-search-sort__head">
            <h3 class="myd-search-sort__title">Sort</h3>
            <button type="button" class="myd-search-sort__close" data-myd-sort-close aria-label="Close">&times;</button>
          </div>
          <div class="myd-search-sort__list"></div>
        </div>
      `;
      document.body.appendChild(root);
      const close = () => root.classList.remove('is-open');
      root.querySelectorAll('[data-myd-sort-close]').forEach((el) => {
        el.addEventListener('click', close);
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && root.classList.contains('is-open')) close();
      });
    } else {
      if (root.parentElement !== document.body) document.body.appendChild(root);
      if (!root.querySelector('.myd-search-sort__overlay')) {
        const overlay = document.createElement('div');
        overlay.className = 'myd-search-sort__overlay';
        overlay.setAttribute('data-myd-sort-close', '');
        overlay.addEventListener('click', () => root.classList.remove('is-open'));
        root.insertBefore(overlay, root.firstChild);
      }
    }
    if (!root.querySelector('[data-myd-sort-close].myd-search-sort__close')) {
      // Upgrade older sheet markup that only had the overlay close target
      const sheet = root.querySelector('.myd-search-sort__sheet');
      const title = root.querySelector('.myd-search-sort__title');
      if (sheet && title && !title.parentElement?.classList.contains('myd-search-sort__head')) {
        const head = document.createElement('div');
        head.className = 'myd-search-sort__head';
        title.replaceWith(head);
        head.appendChild(title);
        const closeBtn = document.createElement('button');
        closeBtn.type = 'button';
        closeBtn.className = 'myd-search-sort__close';
        closeBtn.setAttribute('data-myd-sort-close', '');
        closeBtn.setAttribute('aria-label', 'Close');
        closeBtn.innerHTML = '&times;';
        closeBtn.addEventListener('click', () => root.classList.remove('is-open'));
        head.appendChild(closeBtn);
      }
    }

    const list = root.querySelector('.myd-search-sort__list');
    if (!list) return;
    list.innerHTML = '';
    [...select.options].forEach((opt) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'myd-search-sort__option' + (opt.selected ? ' is-active' : '');
      btn.textContent = opt.textContent;
      btn.addEventListener('click', () => {
        const changed = select.value !== opt.value;
        select.value = opt.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        const form = select.closest('form');
        if (changed) showFacetApplyLoader();
        if (form && typeof form.requestSubmit === 'function') form.requestSubmit();
        else if (form) form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        root.classList.remove('is-open');
      });
      list.appendChild(btn);
    });

    root.classList.add('is-open');
  };

  const activateFacetPanel = (sheet, index) => {
    if (!sheet || !index) return;
    sheet.querySelectorAll('[data-myd-facet-nav-btn]').forEach((btn) => {
      btn.classList.toggle('is-active', btn.getAttribute('data-index') === index);
    });
    sheet.querySelectorAll('.myd-facet-sheet__panel').forEach((panel) => {
      const active = panel.getAttribute('data-index') === index;
      panel.classList.toggle('is-active', active);
      if (active) panel.removeAttribute('hidden');
      else panel.setAttribute('hidden', '');
    });
  };

  const bindFacetSheetNav = () => {
    if (document.documentElement.dataset.mydFacetNavBound) return;
    document.documentElement.dataset.mydFacetNavBound = '1';

    document.addEventListener('click', (event) => {
      const btn = event.target.closest?.('[data-myd-facet-nav-btn]');
      if (!btn) return;
      const sheet = btn.closest('.myd-facet-sheet');
      if (!sheet) return;
      event.preventDefault();
      activateFacetPanel(sheet, btn.getAttribute('data-index'));
    });
  };

  const closeFacetSheet = (sheet) => {
    if (!sheet) return;
    const details = sheet.querySelector('details');
    if (!details?.hasAttribute('open')) return;

    // Call theme drawer close directly (same path Apply uses via summary click)
    if (typeof sheet.closeMenuDrawer === 'function') {
      sheet.closeMenuDrawer(new Event('click'));
      return;
    }

    const summary = details.querySelector(':scope > summary');
    if (summary) summary.click();
  };

  const eventPathHas = (event, selector) => {
    const path = typeof event.composedPath === 'function' ? event.composedPath() : [];
    for (const node of path) {
      if (node instanceof Element && node.matches(selector)) return true;
    }
    // Fallback for older engines / synthetic events
    return Boolean(event.target?.closest?.(selector));
  };

  const isEventInsideFilterSheet = (event) =>
    // Use composedPath so a chip removed mid-click (syncOptionFilterChips) still
    // counts as inside — otherwise body-close treats the detached node as outside.
    eventPathHas(event, '.myd-facet-sheet .mobile-facets__inner') ||
    eventPathHas(event, '.myd-facet-sheet__chip') ||
    eventPathHas(event, '.myd-facet-sheet__chips');

  const bindFacetSheetDrag = () => {
    if (!window.MYDSheetDrag || typeof window.MYDSheetDrag.bind !== 'function') return;
    document.querySelectorAll('.myd-facet-sheet .mobile-facets__inner').forEach((inner) => {
      if (inner.__mydDragBound) return;
      const root = inner.closest('facet-drawer, .myd-facet-sheet');
      const overlay =
        root?.querySelector('[data-myd-facet-close], .myd-facet-sheet__backdrop') || null;
      window.MYDSheetDrag.bind(inner, {
        onClose: () => closeFacetSheet(root),
        overlay,
        handleSelector: '.myd-facet-sheet__grabber, .myd-facet-sheet__handle, [data-myd-sheet-handle]',
        headerSelector: '.mobile-facets__header, .myd-facet-sheet__header, [data-myd-sheet-header]',
        scrollSelector: '.myd-facet-sheet__panels, .mobile-facets__main',
      });
    });
  };

  // Size / Sleeve / Fit / Availability — draft chips + Apply only. Counts from Shopify.
  const STOCK_FILTER_LABELS = ['size', 'sleeve type', 'fit type', 'fit', 'sleeve', 'availability'];

  const isStockFilterLabel = (label) => {
    const l = String(label || '').toLowerCase().trim();
    if (!l) return false;
    return STOCK_FILTER_LABELS.some((name) => l === name || l.includes(name));
  };

  const isFacetSheetOpen = () =>
    Boolean(document.querySelector('.myd-facet-sheet details[open], facet-drawer.myd-facet-sheet details[open]'));

  const METAFIELD_PARAM_LABELS = {
    'filter.p.m.custom.sleeve_type': 'sleeve type',
    'filter.p.m.custom.fit_for_filter': 'fit type',
  };

  const normalizeFilterLabel = (label) => String(label || '').toLowerCase().trim();

  const chipLabelForInput = (input) => {
    const labelEl = input?.closest('label');
    const titled = labelEl?.getAttribute('title')?.trim();
    if (titled) return titled;

    const optionText = labelEl?.querySelector('.myd-facet-sheet__option-text, .color__swatch-label');
    if (optionText) {
      const clone = optionText.cloneNode(true);
      clone.querySelectorAll('.caption-with-letter-spacing').forEach((node) => node.remove());
      const text = clone.textContent.replace(/\s+/g, ' ').trim();
      if (text) return text;
    }

    if (String(input?.name) === 'filter.v.availability') {
      return String(input.value) === '0' ? 'Out of stock' : 'In stock';
    }

    return String(input?.value || '').trim();
  };

  const collectSelectedStockFilters = (options = {}) => {
    const selected = [];
    const seen = new Set();
    const draftOnly = options.draftOnly ?? isFacetSheetOpen();

    const pushSel = (label, value) => {
      if (!isStockFilterLabel(label) || !value) return;
      const key = `${normalizeFilterLabel(label)}::${String(value).toLowerCase()}`;
      if (seen.has(key)) return;
      seen.add(key);
      selected.push({
        label: normalizeFilterLabel(label),
        value: String(value).toLowerCase(),
      });
    };

    document
      .querySelectorAll('#FacetFiltersFormMobile [data-myd-filter-label] input[type="checkbox"]:checked')
      .forEach((input) => {
        const panel = input.closest('[data-myd-filter-label]');
        pushSel(panel?.getAttribute('data-myd-filter-label'), input.value);
      });

    if (!draftOnly) {
      const params = new URLSearchParams(window.location.search);
      params.forEach((value, key) => {
        if (key.startsWith('filter.v.option.')) {
          const optName = key
            .replace('filter.v.option.', '')
            .replace(/\+/g, ' ')
            .replace(/_/g, ' ')
            .toLowerCase();
          pushSel(optName, value);
          return;
        }
        if (key === 'filter.v.availability') {
          pushSel('availability', value);
          return;
        }
        const metaLabel = METAFIELD_PARAM_LABELS[key];
        if (metaLabel) pushSel(metaLabel, value);
      });
    }

    return selected;
  };

  const isCombinedFilterInput = (input) => {
    if (!input?.name) return false;
    if (String(input.name).startsWith('filter.v.option.')) return true;
    if (String(input.name) === 'filter.v.availability') return true;
    return Boolean(METAFIELD_PARAM_LABELS[input.name]);
  };

  const syncOptionFilterCheckboxesFromUrl = () => {
    const params = new URLSearchParams(window.location.search);
    const selected = new Set();
    params.forEach((value, key) => {
      if (
        key.startsWith('filter.v.option.') ||
        key === 'filter.v.availability' ||
        METAFIELD_PARAM_LABELS[key]
      ) {
        selected.add(`${key}::${value}`);
      }
    });

    document.querySelectorAll('#FacetFiltersFormMobile input[type="checkbox"]').forEach((input) => {
      if (!isCombinedFilterInput(input)) return;
      input.checked = selected.has(`${input.name}::${input.value}`);
    });
  };

  let facetSheetApplying = false;
  let facetApplyLoaderTimer = null;

  const ensureFacetApplyLoader = () => {
    let el = document.querySelector('[data-myd-facet-apply-loader]');
    if (el) return el;
    const markSrc =
      window.MYD_LOADER_MARK ||
      document.querySelector('.myd-cart__loader-mark')?.getAttribute('src') ||
      '';
    el = document.createElement('div');
    el.className = 'myd-facet-apply-loader';
    el.setAttribute('data-myd-facet-apply-loader', '');
    el.setAttribute('hidden', '');
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML =
      '<div class="myd-facet-apply-loader__panel myd-cart__loader" role="status" aria-live="polite" aria-label="Updating results">' +
      (markSrc
        ? '<img class="myd-cart__loader-mark myd-facet-apply-loader__mark" src="' +
          markSrc +
          '" alt="" width="52" height="50" decoding="async">'
        : '<span class="myd-facet-apply-loader__spinner" aria-hidden="true"></span>') +
      '</div>';
    document.body.appendChild(el);
    return el;
  };

  const showFacetApplyLoader = () => {
    const el = ensureFacetApplyLoader();
    el.removeAttribute('hidden');
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('myd-facet-apply-loading');
    clearTimeout(facetApplyLoaderTimer);
    facetApplyLoaderTimer = setTimeout(() => hideFacetApplyLoader(), 12000);
  };

  const hideFacetApplyLoader = () => {
    clearTimeout(facetApplyLoaderTimer);
    facetApplyLoaderTimer = null;
    const el = document.querySelector('[data-myd-facet-apply-loader]');
    if (el) {
      el.setAttribute('hidden', '');
      el.setAttribute('aria-hidden', 'true');
    }
    document.documentElement.classList.remove('myd-facet-apply-loading');
  };

  const clearMobileFacetSelections = () => {
    document.querySelectorAll('#FacetFiltersFormMobile input[type="checkbox"]').forEach((input) => {
      if (input.type === 'hidden') return;
      input.checked = false;
      input.disabled = false;
    });
    const wrap = document.querySelector('.myd-facet-sheet__chips');
    if (wrap) {
      wrap.dataset.mydChipKey = '';
      wrap.querySelectorAll('.myd-facet-sheet__chip, facet-remove').forEach((el) => el.remove());
      wrap.classList.add('is-empty');
    }
  };

  const hasDraftFacetSelections = () =>
    [...document.querySelectorAll('#FacetFiltersFormMobile input[type="checkbox"]:checked')].some(
      (input) => isCombinedFilterInput(input)
    );

  const hasAppliedFacetFilters = () => {
    try {
      const params = new URLSearchParams(window.location.search);
      for (const key of params.keys()) {
        if (key.startsWith('filter.')) return true;
      }
    } catch (e) {
      /* ignore */
    }
    return false;
  };

  const syncFacetClearControl = () => {
    const clearBtn = document.querySelector('[data-myd-facet-clear], .myd-facet-sheet__clear');
    if (!clearBtn) return;
    const active = hasDraftFacetSelections() || hasAppliedFacetFilters();
    clearBtn.setAttribute('aria-disabled', active ? 'false' : 'true');
    clearBtn.classList.toggle('is-disabled', !active);
    if ('disabled' in clearBtn) clearBtn.disabled = !active;
  };

  const applyMobileFacetForm = () => {
    const form = document.getElementById('FacetFiltersFormMobile');
    const host = form?.closest('facet-filters-form');
    if (!form || !host || typeof host.createSearchParams !== 'function') return false;
    const params = host.createSearchParams(form).toString();
    if (typeof FacetFiltersForm !== 'undefined' && FacetFiltersForm.renderPage) {
      FacetFiltersForm.renderPage(params, { target: form.querySelector('input') || form });
      return true;
    }
    return false;
  };

  const syncOptionFilterChips = () => {
    const wrap = document.querySelector('.myd-facet-sheet__chips');
    if (!wrap) return;

    const selected = collectSelectedStockFilters();
    const desired = selected
      .map((sel) => {
        const input = [...document.querySelectorAll('#FacetFiltersFormMobile input[type="checkbox"]')].find(
          (el) =>
            isCombinedFilterInput(el) &&
            String(el.value).toLowerCase() === sel.value &&
            normalizeFilterLabel(el.closest('[data-myd-filter-label]')?.getAttribute('data-myd-filter-label')) ===
              sel.label
        );
        if (!input) return null;
        return { key: `${sel.label}::${sel.value}`, label: chipLabelForInput(input), input };
      })
      .filter(Boolean);

    const desiredKeys = desired.map((d) => d.key).join('|');
    if (wrap.dataset.mydChipKey === desiredKeys && wrap.querySelectorAll('[data-myd-option-chip]').length === desired.length) {
      wrap.classList.toggle('is-empty', desired.length === 0);
      return;
    }
    wrap.dataset.mydChipKey = desiredKeys;

    wrap.querySelectorAll('.myd-facet-sheet__chip').forEach((el) => el.remove());

    desired.forEach(({ label, input }) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'myd-facet-sheet__chip';
      btn.setAttribute('data-myd-option-chip', '1');
      const x = document.createElement('span');
      x.setAttribute('aria-hidden', 'true');
      x.textContent = '✕';
      btn.append(x, ` ${label}`);
      btn.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
        input.checked = false;
        input.dispatchEvent(new Event('input', { bubbles: true }));
      });
      wrap.appendChild(btn);
    });

    wrap.classList.toggle('is-empty', !wrap.querySelector('.myd-facet-sheet__chip'));
  };

  const refreshFacetSheetDraft = () => {
    if (!isFacetSheetOpen()) {
      syncOptionFilterCheckboxesFromUrl();
    }
    syncOptionFilterChips();
    syncFacetClearControl();
  };

  const captureFacetSheetDraft = () => {
    syncOptionFilterCheckboxesFromUrl();
    syncOptionFilterChips();
    syncFacetClearControl();
  };

  const ensureSearchParams = () => {
    const params = new URLSearchParams(window.location.search);
    let changed = false;
    const onSearch = window.location.pathname.includes('/search');

    if (onSearch && params.get('q')) {
      if (params.has('options')) {
        params.delete('options');
        changed = true;
      }
      if (params.has('options[unavailable_products]')) {
        params.delete('options[unavailable_products]');
        changed = true;
      }
    if (!params.get('options[prefix]')) {
      params.set('options[prefix]', 'last');
      changed = true;
    }
    }
    if (!changed) return false;

    const query = params.toString();
    const target = query ? `${window.location.pathname}?${query}` : window.location.pathname;
    const guardKey = 'myd_search_param_redirect';
    try {
      if (sessionStorage.getItem(guardKey) === target) {
        sessionStorage.removeItem(guardKey);
        return false;
      }
      sessionStorage.setItem(guardKey, target);
    } catch (e) {
      /* private mode */
    }
    window.location.replace(target);
    return true;
  };

  const bindFacetSheetDraftHelpers = () => {
    if (document.documentElement.dataset.mydFacetDraftBound) return;
    document.documentElement.dataset.mydFacetDraftBound = '1';

    document.addEventListener('myd:facets-rendered', () => {
      refreshFacetSheetDraft();
      clearTimeout(facetApplyLoaderTimer);
      facetApplyLoaderTimer = setTimeout(() => hideFacetApplyLoader(), 120);
    });
    document.addEventListener('collection:reloaded', refreshFacetSheetDraft);
    document.addEventListener('myd:facet-sheet-open', captureFacetSheetDraft);

    let liveSheetTimer = null;
    document.addEventListener(
      'input',
      (event) => {
        const input = event.target;
        if (!(input instanceof HTMLInputElement)) return;
        if (!input.closest?.('#FacetFiltersFormMobile')) return;
        if (!isCombinedFilterInput(input)) return;
        if (!isFacetSheetOpen()) return;
        clearTimeout(liveSheetTimer);
        liveSheetTimer = setTimeout(() => {
          if (!isFacetSheetOpen()) return;
          syncOptionFilterChips();
          syncFacetClearControl();
        }, 80);
      },
      true
    );

    document.addEventListener(
      'toggle',
      (event) => {
        const details = event.target;
        if (!(details instanceof HTMLDetailsElement)) return;
        if (!details.closest?.('.myd-facet-sheet')) return;
        if (details.open) {
          facetSheetApplying = false;
          captureFacetSheetDraft();
          return;
        }
        if (!facetSheetApplying) {
          syncOptionFilterCheckboxesFromUrl();
          syncOptionFilterChips();
        }
        facetSheetApplying = false;
        refreshFacetSheetDraft();
      },
      true
    );
  };

  const bindFacetSheetBackdrop = () => {
    if (document.documentElement.dataset.mydFacetBackdropBound) return;
    document.documentElement.dataset.mydFacetBackdropBound = '1';

    bindFacetSheetDrag();
    document.addEventListener('myd:facet-sheet-open', bindFacetSheetDrag);
    // Facet drawers can mount late
    setTimeout(bindFacetSheetDrag, 500);
    setTimeout(bindFacetSheetDrag, 2000);

    const maybeCloseFromOutside = (event) => {
      const sheet = document.querySelector('.myd-facet-sheet details[open]')?.closest('facet-drawer, .myd-facet-sheet');
      if (!sheet) return;
      if (isEventInsideFilterSheet(event)) return;
      if (event.target.closest?.('[data-myd-open-filters]')) return;
      if (event.target.closest?.('.myd-search-sort')) return;
      if (event.target.closest?.('summary')) return;
      closeFacetSheet(sheet);
    };

    // Apply → close only. Checkbox / chip already live-AJAX like Be Yours.
    // Clear → uncheck and re-fetch when something is selected. Empty Clear
    // must not reset the grid (that was resurrecting a dead Load more).
    document.addEventListener(
      'click',
      (event) => {
        const applyBtn = event.target.closest?.('[data-myd-facet-apply]');
        if (applyBtn) {
          event.preventDefault();
          event.stopPropagation();
          if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
          facetSheetApplying = true;
          closeFacetSheet(applyBtn.closest('facet-drawer, .myd-facet-sheet'));
          return;
        }

        const clearBtn = event.target.closest?.('[data-myd-facet-clear], .myd-facet-sheet__clear');
        if (clearBtn) {
          event.preventDefault();
          event.stopPropagation();
          if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();

          // No Size/Sleeve/Fit (draft or applied) → Clear is a hard no-op.
          // Do not close, re-fetch, or reset Load more / ?page=N.
          const hadApplied = hasAppliedFacetFilters();
          const hadDraft = hasDraftFacetSelections();
          if (!hadApplied && !hadDraft) return;
          if (!isFacetSheetOpen()) return;

          clearMobileFacetSelections();
          syncOptionFilterChips();
          syncFacetClearControl();

          if (hadApplied) {
            facetSheetApplying = true;
            showFacetApplyLoader();
            applyMobileFacetForm();
          }
          closeFacetSheet(clearBtn.closest('facet-drawer, .myd-facet-sheet'));
          return;
        }
      },
      true
    );

    // Backdrop button (dimmed area above the sheet)
    document.addEventListener('click', (event) => {
      const closeBtn = event.target.closest?.('[data-myd-facet-close]');
      if (closeBtn) {
        event.preventDefault();
        event.stopPropagation();
        closeFacetSheet(closeBtn.closest('facet-drawer, .myd-facet-sheet'));
        return;
      }
      maybeCloseFromOutside(event);
    });

    // Capture early so overlay / page taps always reach us
    document.addEventListener('pointerdown', maybeCloseFromOutside, true);

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const sheet = document.querySelector('.myd-facet-sheet details[open]')?.closest('facet-drawer, .myd-facet-sheet');
      if (sheet) closeFacetSheet(sheet);
    });
  };

  const patchFacetDrawerOutsideClose = () => {
    const applyPatch = () => {
      const Ctor = customElements.get('facet-drawer');
      if (!Ctor || Ctor.prototype.__mydOutsideClosePatched) return;
      Ctor.prototype.__mydOutsideClosePatched = true;

      const originalBodyClick = Ctor.prototype.onBodyClick;
      Ctor.prototype.onBodyClick = function (event) {
        if (this.classList.contains('myd-facet-sheet')) {
          const path = typeof event.composedPath === 'function' ? event.composedPath() : [];
          const inside = path.some(
            (node) =>
              node instanceof Element &&
              node.matches(
                '.mobile-facets__inner, .myd-facet-sheet__chip, .myd-facet-sheet__chips, [data-myd-open-filters], [data-myd-open-sort], .myd-search-sort'
              )
          );
          if (
            inside ||
            event.target?.closest?.(
              '.mobile-facets__inner, .myd-facet-sheet__chip, .myd-facet-sheet__chips, [data-myd-open-filters], [data-myd-open-sort], .myd-search-sort'
            )
          ) {
            return;
          }
          this.closeMenuDrawer(event);
          return;
        }
        if (typeof originalBodyClick === 'function') originalBodyClick.call(this, event);
      };
    };

    if (customElements.get('facet-drawer')) applyPatch();
    else customElements.whenDefined('facet-drawer').then(applyPatch);
  };

  const setCardHeartUI = (button, hearted) => {
    if (!button) return;
    button.classList.toggle('is-hearted', !!hearted);
    button.setAttribute('aria-pressed', hearted ? 'true' : 'false');
    button.setAttribute('aria-label', hearted ? 'Remove from wishlist' : 'Add to wishlist');
  };

  /** Cart YML: wishlisted items get a Top-Seller-style badge; heart is hidden. */
  const applyYmlWishlistPresentation = (card, hearted) => {
    if (!card?.classList?.contains('myd-cart__yml-card')) return;
    const media = card.querySelector('.myd-search-card__media');
    if (!media) return;

    let badge = media.querySelector('.myd-search-card__wishlisted');
    const wishBtn = media.querySelector('[data-myd-wish]');

    if (hearted) {
      if (!badge) {
        badge = document.createElement('div');
        badge.className = 'myd-search-card__wishlisted';
        badge.textContent = 'Wishlisted';
        media.appendChild(badge);
      }
      if (wishBtn) {
        wishBtn.hidden = true;
        wishBtn.setAttribute('aria-hidden', 'true');
        wishBtn.tabIndex = -1;
      }
    } else {
      badge?.remove();
      if (wishBtn) {
        wishBtn.hidden = false;
        wishBtn.removeAttribute('aria-hidden');
        wishBtn.removeAttribute('tabindex');
      }
    }
  };

  const syncCardWishButtons = (root = document) => {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-myd-wish]').forEach((btn) => {
      const handle = btn.getAttribute('data-product-handle');
      setCardHeartUI(btn, !!(handle && window.MydWishlist?.hasItem(handle)));
    });
    scope.querySelectorAll('.myd-cart__yml-card[data-product-handle]').forEach((card) => {
      const handle = card.getAttribute('data-product-handle');
      applyYmlWishlistPresentation(card, !!(handle && window.MydWishlist?.hasItem(handle)));
    });
  };

  /** Keep every card / sheet heart for a product in sync across grids on the same page. */
  const broadcastProductWish = (handle, hearted) => {
    if (!handle) return;
    document.querySelectorAll(`[data-myd-wish][data-product-handle="${handle}"]`).forEach((btn) => {
      setCardHeartUI(btn, hearted);
    });
    document.querySelectorAll(`[data-myd-qa-wish][data-product-handle="${handle}"]`).forEach((btn) => {
      setCardHeartUI(btn, hearted);
    });
    // You Might Like / Luxury grid cards use custom classes (not data-myd-wish)
    document
      .querySelectorAll(
        `[class*="ai-you-might-like-wish-"][data-product-handle="${handle}"], [class*="ai-you-might-like-modal-wish-"][data-product-handle="${handle}"], [class*="luxury-card-wish-"][data-product-handle="${handle}"]`
      )
      .forEach((btn) => {
        setCardHeartUI(btn, hearted);
      });
    document.querySelectorAll(`.myd-cart__yml-card[data-product-handle="${handle}"]`).forEach((card) => {
      applyYmlWishlistPresentation(card, !!hearted);
    });
    // Keep PDP heart in sync when cards toggle the same product
    try {
      window.MYDPdpWishlist?.syncAll?.();
    } catch (e) {}
    try {
      document.dispatchEvent(
        new CustomEvent('myd:wishlist-change', { detail: { handle, hearted: !!hearted } })
      );
    } catch (e) {}
  };

  window.MYDWishUI = {
    sync: syncCardWishButtons,
    broadcast: broadcastProductWish,
    isSaved: (handle) => !!(handle && window.MydWishlist?.hasItem(handle))
  };

  const toggleCardWish = (button) => {
    const handle = button.getAttribute('data-product-handle') || '';
    if (!handle || !window.MydWishlist) return;

    const already = window.MydWishlist.hasItem(handle);
    window.MydWishlist.toggle('default', handle);
    broadcastProductWish(handle, !already);

    if (!already && window.MYDPdpWishlist) {
      window.MYDPdpWishlist._pendingAnchor = button;
      window.MYDPdpWishlist.onWishAdded(button);
      if (!window.MYDPdpWishlist.isLoggedIn()) {
        window.setTimeout(() => window.MYDPdpWishlist.showLoginPrompt(), 50);
      }
    }
  };

  const bindCardWishButtons = () => {
    if (document.documentElement.dataset.mydCardWishBound) return;
    document.documentElement.dataset.mydCardWishBound = '1';

    document.addEventListener('click', (event) => {
      const btn = event.target.closest?.('[data-myd-wish]');
      if (!btn) return;
      // Luxury grid binds its own buttons; skip those
      if (btn.className && String(btn.className).includes('luxury-card-wish-')) return;
      event.preventDefault();
      event.stopPropagation();
      toggleCardWish(btn);
    });

    syncCardWishButtons();
    document.addEventListener('wishlist:updated', () => syncCardWishButtons());
    document.addEventListener('myd:yml-init', () => syncCardWishButtons());

    // Cards injected after boot (cart drawer, recommendations, search results)
    // never pass through the initial sync, so their hearts stay blank.
    let pendingSync = 0;
    const observer = new MutationObserver((mutations) => {
      const addedCard = mutations.some((m) =>
        [...m.addedNodes].some(
          (node) =>
            node.nodeType === 1 &&
            (node.matches?.('[data-myd-wish], .myd-cart__yml-card') ||
              node.querySelector?.('[data-myd-wish], .myd-cart__yml-card'))
        )
      );
      if (!addedCard || pendingSync) return;
      pendingSync = setTimeout(() => {
        pendingSync = 0;
        syncCardWishButtons();
      }, 60);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };

  const formatCardRating = (avg) => {
    const n = Number.parseFloat(avg);
    if (!(n > 0)) return '';
    const rounded = Math.round(n * 10) / 10;
    return Number.isInteger(rounded) ? `${rounded}.0` : String(rounded);
  };

  const applyCardRating = (el, avg, count) => {
    const score = formatCardRating(avg);
    if (!score) return false;
    const scoreEl = el.querySelector('[data-myd-card-rating-score]');
    if (scoreEl) scoreEl.textContent = score;
    el.classList.remove('is-empty');
    el.removeAttribute('aria-hidden');
    el.removeAttribute('tabindex');
    const reviews = Number.parseInt(count, 10) || 0;
    el.setAttribute(
      'aria-label',
      reviews > 0
        ? `Rated ${score} from ${reviews} review${reviews === 1 ? '' : 's'}`
        : `Rated ${score}`
    );
    el.dataset.mydRatingReady = '1';
    const btn = el.closest('.myd-search-card, [class*="luxury-card-"]')?.querySelector('[data-myd-quick-add]');
    if (btn) {
      btn.setAttribute('data-rating', String(avg));
      if (reviews > 0) btn.setAttribute('data-rating-count', String(reviews));
    }
    return true;
  };

  const hydrateCardRatings = () => {
    document.querySelectorAll('[data-myd-card-rating]').forEach((el) => {
      if (el.dataset.mydRatingReady === '1') return;
      if (!el.classList.contains('is-empty')) {
        const existing = el.querySelector('[data-myd-card-rating-score]')?.textContent?.trim();
        if (existing) {
          el.dataset.mydRatingReady = '1';
          return;
        }
      }
      const prev =
        el.querySelector('.jdgm-prev-badge[data-average-rating]') ||
        el.querySelector('.jdgm-preview-badge .jdgm-prev-badge');
      const avg = Number.parseFloat(prev?.getAttribute('data-average-rating') || '');
      const count = Number.parseInt(prev?.getAttribute('data-number-of-reviews') || '0', 10);
      if (avg > 0) applyCardRating(el, avg, count);
    });
  };

  const watchCardRatings = () => {
    if (window.__mydCardRatingWatch) return;
    window.__mydCardRatingWatch = true;
    hydrateCardRatings();
    window.MYDJudgeMe?.scheduleEnhance?.();
    const mo = new MutationObserver(() => hydrateCardRatings());
    mo.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-average-rating', 'data-number-of-reviews', 'class'],
    });
    // Judge.me often fills badges after its widget JS boots
    [300, 800, 1600, 3200].forEach((ms) => setTimeout(hydrateCardRatings, ms));
    document.addEventListener('myd:card-ratings-refresh', () => hydrateCardRatings());
  };

  const mountSearchDrawerGroup = () => {
    const host = document.querySelector('[data-myd-search-drawer-group]');
    if (!host || host.dataset.mydMounted === '1') return;

    const slots = [
      ...document.querySelectorAll('search-modal [data-myd-search-drawer-slot]'),
      ...document.querySelectorAll('.myd-search-page.template-search--empty [data-myd-search-drawer-slot]'),
    ];
    if (!slots.length) return;

    slots.forEach((slot, index) => {
      if (slot.dataset.mydFilled === '1') return;
      const node = index === 0 ? host : host.cloneNode(true);
      node.hidden = false;
      node.removeAttribute('id');
      node.classList.add('is-mounted');
      node.dataset.mydSearchDrawerMounted = '1';
      slot.appendChild(node);
      slot.dataset.mydFilled = '1';
    });
    host.dataset.mydMounted = '1';
    hydrateCardRatings();
    window.MYDJudgeMe?.scheduleEnhance?.();
  };

  const boot = () => {
    if (ensureSearchParams()) return;
    mountSearchDrawerGroup();
    window.MYDSearchRecent.renderAll();
    bindSearchForms();
    bindToolbar();
    bindFacetSheetNav();
    bindFacetSheetBackdrop();
    bindFacetSheetDraftHelpers();
    patchFacetDrawerOutsideClose();
    bindCardWishButtons();
    watchCardRatings();
    refreshFacetSheetDraft();
  };

  document.addEventListener('myd:recent-searches', () => window.MYDSearchRecent.renderAll());

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
